import { render } from "./ChallengeCloneModal.vue?vue&type=template&id=71a6b470&scoped=true"
import script from "./ChallengeCloneModal.vue?vue&type=script&lang=js"
export * from "./ChallengeCloneModal.vue?vue&type=script&lang=js"

import "./ChallengeCloneModal.vue?vue&type=style&index=0&id=71a6b470&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71a6b470"]])

export default __exports__